import { NodeDef } from "../type/node-def";

export class NodeAdapter {
  // 既定は true。is_smallytics の出し分けは relevance 側で行うため、
  // 現状どの画面も引数を渡していない (受け口だけ残してある)。
  static toInputDTO(isSmallytics: boolean = true): any {
    return {
      is_past_look: true,
      is_smallytics: isSmallytics,
    };
  }

  static toOutputDTO(res: any): NodeDef {
    return (
      res.outcome_columns?.map((node: any, index: number) => ({
        id: index,
        key: node.column,
        value: false,
        meta: {
          column: node.column,
          lag_time_one_day: node.lag_time_one_day,
          lag_time_one_month: node.lag_time_one_month,
          lag_time_one_week: node.lag_time_one_week,
          lag_time_quarter_day: node.lag_time_quarter_day,
          variable_type: node.variable_type,
          layer: node.layer,
          is_variable: node.variable_type === 1 ? true : false,
        },
      })) || []
    );
  }
}
